import type { FeatureManifest } from '../registry.js';

/** SO-06 friends (SCR-10): invite link + QR, the list, a friend's street, unfriend / block. SO-05 /f/:code. */
export default {
  id: 'friends',
  unlock: 'friends',
  online: true,
  art: ['pip_extra'],
  provides: ['friends', 'friendStreet', 'friendMenu'],
  links: ['friend'],
  entry: { order: 3, icon: 'friends', label: 'rail.friends', testId: 'rail-friends', open: 'friends' },
  load: () => import('./index.js'),
} satisfies FeatureManifest;
